import styled from 'styled-components';
import { RadioInput } from '@app/src/common/RadioInput';
import { FONTS, COLORS } from '@app/src/ui';

interface Props {
  isDisplay?: boolean;
}

export const Description = styled.p`
  margin-left: 6px;
  font-family: ${FONTS.OPEN_SANS};
  font-size: 16px;
`;

export const RadioInputWrapper = styled(RadioInput)`
  display: inline-flex;
`;

export const Price = styled.span`
  font-size: 13px;
  color: ${COLORS.GRAY_TEXT};
`;

export const List = styled.ul`
  margin-top: 14px;
`;

export const Item = styled.li`
  height: 30px;
  ${(props: Props) => props.isDisplay ? `
    display: block;
  `:`
    display: none;
  `}
`;

export const Title = styled.h3`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 14px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
`;

export const IconInfo = styled.span`
  cursor: pointer;
  display: inline-block;
  height: 17px;
  margin-left: 4px;
`;

export const ModalContent = styled.p`
  width: 250px;
  margin: 50px 30px 30px;
  font-family: ${FONTS.OPEN_SANS};
  text-align: center;
`;
